// Docs:
// https://developers.google.com/tag-platform/security/concepts/consent-mode
// https://shopify.dev/docs/api/customer-privacy#check-data-processing-permissions

/**
 * feedback
 * @description Log the tracking status to the console.
 */
function feedback() {
  const p = Shopify.customerPrivacy;
  console.log(`Tracking ${p.userCanBeTracked() ? 'en' : 'dis'}abled`);
}
/**
 * Shopify.loadFeatures
 * @description Load the Shopify Customer Privacy JavaScript library. With callback and event listeners.
 */
Shopify.loadFeatures(
  [
    {
      name: 'consent-tracking-api',
      version: '0.1',
    },
  ],
  (error) => {
    if (error) throw error;
    feedback();
    // Set state if it is already set

    if (!('gtag' in window)) return;

    // Set default consent
    gtag('consent', 'default', {
      ad_personalization: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      analytics_storage: 'denied',
      functionality_storage: 'denied',
      personalization_storage: 'denied',
      security_storage: 'granted',
      wait_for_update: 500,
    });
    gtag('set', 'ads_data_redaction', true);
    gtag('set', 'url_passthrough', true);

    handleConsent();
    // Event
    document.addEventListener('visitorConsentCollected', function (event) {
      console.log('> visitorConsentCollected');
      handleConsent();
    });
  }
);
/**
 * handleConsent
 * @description Bridge consent object to Shopify's Web Pixel based on user consent choices.
 */
function handleConsent() {
  const event_name = 'consent_update';
  const event_data = {
    ad_personalization: window.Shopify.customerPrivacy.marketingAllowed() ? 'granted' : 'denied',
    ad_storage: window.Shopify.customerPrivacy.marketingAllowed() ? 'granted' : 'denied',
    ad_user_data: window.Shopify.customerPrivacy.marketingAllowed() ? 'granted' : 'denied',
    personalization_storage: window.Shopify.customerPrivacy.marketingAllowed()
      ? 'granted'
      : 'denied',
    analytics_storage: window.Shopify.customerPrivacy.analyticsProcessingAllowed()
      ? 'granted'
      : 'denied',
    functionality_storage: window.Shopify.customerPrivacy.preferencesProcessingAllowed()
      ? 'granted'
      : 'denied',
    security_storage: window.Shopify.customerPrivacy.preferencesProcessingAllowed()
      ? 'granted'
      : 'denied',
    wait_for_update: 500,
  };
  gtag('consent', 'update', event_data);
  Shopify.analytics.publish(event_name, event_data);
  feedback();
}
